/**
 * Project utility functions for filtering, sorting, and data processing
 */

/**
 * Filter projects based on search query
 * @param {Array} projects - Array of project objects
 * @param {string} searchQuery - Search query string
 * @returns {Array} - Filtered array of projects
 */
export function filterProjects(projects, searchQuery) {
    if (!searchQuery.trim()) return [...projects];
    
    const q = searchQuery.toLowerCase();
    return projects.filter(p => 
        p.name.toLowerCase().includes(q) || 
        (p.description || '').toLowerCase().includes(q)
    );
}

/**
 * Sort projects based on sort field and order
 * @param {Array} projects - Array of project objects
 * @param {string} sortBy - Field to sort by ('name', 'updatedAt', 'createdAt', 'createdBy')
 * @param {string} sortOrder - Sort order ('asc' or 'desc')
 * @returns {Array} - Sorted array of projects
 */
export function sortProjects(projects, sortBy, sortOrder) {
    return [...projects].sort((a, b) => {
        let valA = a[sortBy] || '';
        let valB = b[sortBy] || '';
        
        if (sortBy === 'createdAt' || sortBy === 'updatedAt') {
            valA = new Date(valA).getTime();
            valB = new Date(valB).getTime();
        } else if (typeof valA === 'string') {
            valA = valA.toLowerCase();
            valB = String(valB).toLowerCase();
        }

        if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
        if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
        return 0;
    });
}

/**
 * Get sorted and filtered projects
 * @param {Array} projects - Array of project objects
 * @param {string} searchQuery - Search query string
 * @param {string} sortBy - Field to sort by
 * @param {string} sortOrder - Sort order
 * @returns {Array} - Processed array of projects
 */
export function getProcessedProjects(projects, searchQuery, sortBy, sortOrder) {
    const filtered = filterProjects(projects, searchQuery);
    return sortProjects(filtered, sortBy, sortOrder);
}